import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider as AntdConfigProvider } from "antd";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
// import "antd/dist/antd.variable.min.css";
import store from "./store";
import { antdTheme } from "utils/antd";
import "./assets/styles/styles.scss";
import "react-multi-carousel/lib/styles.css";

import App from "./App";
import { I18nextProvider } from "react-i18next";
import i18n from "locales";

const root = ReactDOM.createRoot(document.getElementById("root"));
const persistor = persistStore(store);

const Index = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <AntdConfigProvider theme={antdTheme}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AntdConfigProvider>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  );
};
root.render(<Index />);
